function initGeroCards() {
  document.querySelectorAll('.gero-img-hover').forEach((wrapper) => {
    if ('true' === wrapper.dataset.geroCardInit) {
      return;
    }

    const card = wrapper.querySelector(':scope > .gero-card-hovered');
    const mainLink = card && card.querySelector(':scope > a');
    const img = mainLink && mainLink.querySelector('img');
    const tilesWrapper = card && card.querySelector(':scope > div');
    const tiles = card ? card.querySelectorAll('.gero-img-hover-tile') : [];

    if (!card || !img || !mainLink || !tilesWrapper || !tiles.length) {
      return;
    }

    wrapper.dataset.geroCardInit = 'true';

    const defaultSrc = img.src;
    const defaultHref = mainLink.getAttribute('href');
    const defaultTile = tiles[0];

    let ready = false;

    function setActiveTile(tile) {
      img.src = tile.dataset.hoverSrc;
      mainLink.href = tile.href;

      for (const otherTile of tiles) {
        otherTile.classList.toggle('is-active', otherTile === tile);
      }
    }

    tilesWrapper.addEventListener('transitionend', (event) => {
      if (tilesWrapper === event.target && 'width' === event.propertyName) {
        ready = tilesWrapper.offsetWidth > 0;
      }
    });

    for (const tile of tiles) {
      tile.addEventListener('mouseenter', () => {
        if (ready) {
          setActiveTile(tile);
        }
      });
    }

    wrapper.addEventListener('mouseleave', () => {
      ready = false;
      img.src = defaultSrc;

      if (defaultHref) {
        mainLink.setAttribute('href', defaultHref);
      }

      for (const otherTile of tiles) {
        otherTile.classList.toggle('is-active', otherTile === defaultTile);
      }
    });
  });
}

initGeroCards();
document.addEventListener('facets:change', initGeroCards);
